import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, NAV } from "../../content/site";

export const Footer = () => (
  <footer className="relative bg-[color:var(--navy-deep)] text-slate-300 grain overflow-hidden" data-testid="site-footer">
    <div className="container-x relative pt-20 pb-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light className="h-10 md:h-12" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">
            Internationale Direktvermittlung von Arbeitskräften aus dem Ausland an Unternehmen in ganz Deutschland. Mit Sitz in Lübeck.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#7CC4BF]">Seiten</p>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.to}><Link className="link-underline hover:text-white" to={n.to} data-testid={`footer-nav-${n.to.slice(1)}`}>{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#7CC4BF]">Kontakt</p>
          <address className="mt-5 not-italic space-y-4 text-sm">
            <a href={COMPANY.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex gap-3 hover:text-white" data-testid="footer-address-link">
              <MapPin size={18} className="mt-0.5 shrink-0 text-[#7CC4BF]" />
              <span>{COMPANY.brand}<br />{COMPANY.street}<br />{COMPANY.city}</span>
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex gap-3 hover:text-white" data-testid="footer-email-link">
              <Mail size={18} className="mt-0.5 shrink-0 text-[#7CC4BF]" /> {COMPANY.email}
            </a>
          </address>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-slate-400 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} PACTORA Personalpartner</p>
        <div className="flex flex-wrap gap-6">
          <Link to="/impressum" className="hover:text-white" data-testid="footer-imprint-link">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-white" data-testid="footer-privacy-link">Datenschutz</Link>
          <Link to="/intern" className="hover:text-white" data-testid="footer-team-link">Team-Login</Link>
        </div>
      </div>
    </div>
  </footer>
);
